import React from 'react';
import './Oil.css';
import icon1 from '../../../assets/IconsTrusted-by-traders-across-Dubai.png';
import icon2 from '../../../assets/IconsTransparent-fees-&-real-time-market-access.png';
import icon3 from '../../../assets/IconsFully-secure-platform.png';
import icon4 from '../../../assets/Icons-Backed-by-professional-support.png';

const translations = {
  en: {
    heroSubtitle: "The oil market is calling—Are you ready to answer?",
    heroTitle: "Don’t just watch the oil market—Trade it with GivTrade",
    heroDescription: "Oil is on the move. Are you prepared?",
    buttonText: "Start trading oil now",
    sectionTitle: "Oil prices are moving, it’s time to take action and profit.",
    sectionDescription: "GivTrade makes oil trading easy, fast, and secure. Open your account in minutes, get 24/7 support, and start trading oil today.",
    whyTradeTitle: "Why trade Oil with GivTrade?",
    benefits: [
      "Spreads starting at 0.0 Pip",
      "Fast & Safe Deposits and Withdrawals",
      "Easy Account Opening",
      "24/7 Support",
      "Competitive Commissions",
      "Trade from Anywhere, Anytime"
    ],
    ctaTitle: "Get started",
    ctaDescription: "Open your account instantly.",
    ctaBenefits: [
      "Trusted by traders across Dubai",
      "Fully secure platform",
      "Transparent fees & real-time market access",
      "Backed by professional support"
    ],
    ctaBtn: "Open Your Account"
  },
  ar: {
    heroSubtitle: "سوق النفط يناديك – هل أنت مستعد للاستجابة؟",
    heroTitle: "لا تكتفِ بمراقبة سوق النفط – تداول مع GivTrade",
    heroDescription: "النفط يتحرك. هل أنت مستعد؟",
    buttonText: "ابدأ تداول النفط الآن",
    sectionTitle: "أسعار النفط تتحرك، حان الوقت لاتخاذ خطوة وجني الأرباح.",
    sectionDescription: "تداول النفط مع GivTrade سهل وسريع وآمن. افتح حسابك خلال دقائق واحصل على دعم 24/7 وابدأ التداول الآن.",
    whyTradeTitle: "لماذا تتداول النفط مع GivTrade؟",
    benefits: [
      "فروقات تبدأ من 0.0 نقطة",
      "إيداعات وسحوبات سريعة وآمنة",
      "فتح حساب بسهولة",
      "دعم متوفر على مدار الساعة",
      "عمولات تنافسية",
      "تداول في أي وقت ومن أي مكان"
    ],
    ctaTitle: "ابدأ الآن",
    ctaDescription: "افتح حسابك فوراً.",
    ctaBenefits: [
      "موثوق من قبل المتداولين في دبي",
      "منصة آمنة بالكامل",
      "رسوم شفافة ووصول لحظي للسوق",
      "مدعوم بدعم فني احترافي"
    ],
    ctaBtn: "افتح حسابك"
  }
};

const Oil = ({ language = 'en' }) => {
  const t = translations[language];

  return (
    <div className='full'>
      <div className='forex-container font-sans text-white'>

        {/* HERO SECTION */}
        <div className="hero-section-oil">
          <div className="hero-overlay" />
          <div className="hero-content">
            <p className="hero-subtitle">{t.heroSubtitle}</p>
            <h1 className="hero-title">
              {t.heroTitle.split('GivTrade')[0]}
              <span className="highlight">GivTrade</span>
            </h1>
            <p className="hero-description">{t.heroDescription}</p>
            <button className="hero-button" onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/9', '_blank')}>
              {t.buttonText}
            </button>
          </div>
        </div>

        {/* SECTION 2 */}
        <section className='section py-10'>
          <p className='section-title'>{t.sectionTitle}</p>
          <p className='section-description'>{t.sectionDescription}</p>
        </section>

        {/* SECTION 3 */}
        <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
          <div>
            <h2 className='section-heading'>{t.whyTradeTitle}</h2>
            <ul className='benefits-list'>
              {t.benefits.map((benefit, idx) => (
                <li key={idx}>
                  <strong className='benefit-title'>{benefit}</strong>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className='section'>
          <div className='cta-box text-center'>
            <h3 className='cta-title'>{t.ctaTitle}</h3>
            <p className='cta-description'>{t.ctaDescription}</p>
            <ul className='cta-benefits'>
              {[icon1, icon3, icon2, icon4].map((icon, idx) => (
                <li className='cta-lable flex flex-col items-center gap-1 text-center' key={idx}>
                  <img src={icon} alt='Check' className='icon' />
                  {t.ctaBenefits[idx]}
                </li>
              ))}
            </ul>
            <button
              className='cta-button mx-auto block'
              onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/9', '_blank')}
            >
              {t.ctaBtn}
            </button>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Oil;